<h1 mat-dialog-title>Confirmation</h1>
<div mat-dialog-content>
    {{ message }}
</div>
<div mat-dialog-actions>
    <button mat-raised-button color="primary" (click)="onNoClick()" cdkFocusInitial>No</button>
    <button mat-raised-button color="primary" class="critical" [mat-dialog-close]="true">Yes</button>
</div>